import React  from 'react';
import { ReferenceArrayField, SingleFieldList, ChipField, TextField, CloneButton } from "react-admin";
import { ListGuesser } from "@api-platform/admin";

const CloneElement = ({ record }) => {
  const omitId = ({ id, originId, uuid, ...rest }) => rest;
  delete record["@type"];
  delete record["@id"];

  return (<CloneButton to={{
          pathname: `step_types/create`,
          state: { record: omitId(record) }
        }}/>);
};

const StepTypeList = (props) => (
    <ListGuesser {...props}>
      <TextField source="name" />
      <TextField source="type" />
      <ReferenceArrayField
        label="Type values"
        reference="step_type_values"
        source="stepTypeValues"
      >
        <SingleFieldList>
            <ChipField source="title" />
        </SingleFieldList>
      </ReferenceArrayField>
      <CloneElement />
    </ListGuesser>
);

export default StepTypeList;